import { getCurrentInstance, reactive, ref, watch } from 'vue';
import apiClient from '@src/api/api-client';
import { Product } from '@src/product/interfaces/product.ts';

export interface ItemInfoProps {
    idProduct?: number,
    sku?: string,
    product?: Product,
    serials?: Array<string>,
    idBin?: number,
    withoutLinks?: boolean,
}

export function useItemInfoComposable() {
    const loading = ref(true);

    const { props }: { props: ItemInfoProps } = getCurrentInstance()!;
    if (Object.keys(props).length === 0) {
        throw new Error('no props given, did you forget do call defineProps?');
    }

    const product = reactive(props.product ?? {} as Product);

    watch(
        [
            () => props.idProduct,
            () => props.sku,
            () => props.product,
        ],
        () => loadProduct(),
        { immediate: true },
    );

    async function loadProduct() {
        loading.value = true;
        if (props.product) {
            if (product.idProduct !== props.product.idProduct) {
                Object.assign(product, props.product);
            }
            if (!props.product.productAbstract || Object.keys(props.product.productAbstract).length <= 1) {
                Object.assign(product, await getProductDataById(props.product.idProduct));
            }
        } else if (props.idProduct) {
            Object.assign(product, await getProductDataById(props.idProduct));
        } else if (props.sku) {
            Object.assign(product, await getProductDataBySku(props.sku));
        } else {
            throw new Error('no identifier or object was given');
        }
        loading.value = false;
    }
    async function getProductDataById(id: number) {
        return (await apiClient.get('/be/product/' + id)).data;
    }

    async function getProductDataBySku(sku: string) {
        return (await apiClient.get('/be/product-by-sku/' + sku)).data;
    }

    return {
        product,
        loading,
    };
}
